import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LangToggle, useLang } from "@/lib/i18n";
import api, { API } from "@/lib/api";

export default function InsightDetail() {
  const { id } = useParams();
  const { t } = useLang();
  const [post, setPost] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    api.get(`/content/insights/${id}`)
      .then(({ data }) => setPost(data))
      .catch(() => setMissing(true));
  }, [id]);

  useEffect(() => {
    if (!post) return;
    const prevTitle = document.title;
    document.title = post.meta_title || `${post.title} — Norex International Trading Ltd.`;
    const meta = document.querySelector('meta[name="description"]');
    const prevDesc = meta?.getAttribute("content");
    if (meta) meta.setAttribute("content", post.meta_description || post.excerpt);
    return () => {
      document.title = prevTitle;
      if (meta && prevDesc) meta.setAttribute("content", prevDesc);
    };
  }, [post]);

  return (
    <div data-testid="insight-detail-page" className="min-h-screen bg-midnight">
      <div className="max-w-3xl mx-auto px-6 py-10">
        <div className="flex items-center justify-between mb-14">
          <Link to="/insights" data-testid="insight-back-link" className="inline-flex items-center gap-2 text-sm text-[#94A3B8] hover:text-gold transition-colors duration-200">
            <ArrowLeft className="w-4 h-4" /> {t.insights.back}
          </Link>
          <LangToggle compact />
        </div>

        {missing ? (
          <p className="text-[#94A3B8]" data-testid="insight-not-found">{t.insights.empty}</p>
        ) : !post ? (
          <p className="text-[#94A3B8]">...</p>
        ) : (
          <article>
            <p className="text-[10px] uppercase tracking-[0.25em] text-gold mb-4">
              {post.category} · {new Date(post.created_at).toLocaleDateString()}
            </p>
            <h1 className="text-3xl md:text-4xl tracking-tight font-bold text-[#F4F6F8] mb-8" data-testid="insight-detail-title">
              {post.title}
            </h1>
            {post.cover && (
              <div className="border border-[#1E293B] mb-10 overflow-hidden">
                <img src={`${API}/public/files/${post.cover.storage_path}`} alt={post.title} className="w-full max-h-[420px] object-cover" />
              </div>
            )}
            <div className="space-y-6" data-testid="insight-detail-body">
              {post.body.split(/\n\s*\n/).map((para, i) => (
                <p key={i} className="text-base text-[#C6D0DD] leading-relaxed">{para}</p>
              ))}
            </div>
            <p className="mt-14 pt-6 border-t border-[#1E293B] text-xs text-[#94A3B8]">
              Norex International Trading Ltd. — {t.insights.eyebrow}
            </p>
          </article>
        )}
      </div>
    </div>
  );
}
